import { render, staticRenderFns } from "./WorkspacesList.vue?vue&type=template&id=6258de0b&"
import script from "./WorkspacesList.vue?vue&type=script&lang=js&"
export * from "./WorkspacesList.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports